import React, { useEffect, useState } from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import LoginBody from "./widget/LoginBody";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import Center from "../../../widget/common/ui/Center";
import { LoginContextProvider } from "../../../provider/onboarding/login/LoginContextProvider";
import { Col } from "react-bootstrap";

const LoginScreen = () => {
  const type: number = ResponsiveDeviceType();
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      console.log(window.innerHeight);
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <LoginContextProvider>
      <Scaffold>
        <Center
          className={`vh-100- ${height > 868 ? "dvh-100" : "py-4"}  ${
            type === 3 ? "bgcolor-grey4 overflow-auto" : ""
          }`}
        >
          <Col
            className="bgcolor-white py-lg-4  px-lg-4 px-xl-5 login-wrap"
            xs={9}
            md={8}
            lg={6}
            xl={5}
          >
            <LoginBody />
          </Col>
        </Center>
      </Scaffold>
    </LoginContextProvider>
  );
};

export default LoginScreen;
export const routeName: string = "/login";
